import React from 'react';
import { generateRandomKey } from '../../abs/views/absui/ABSProductCompare/util';
import ABSInput from '../ABSInput';

export interface IABSDeletableTableDataHelperProps {
  
}
 
export interface IABSDeletableTableDataHelperState {
  
}
 
class ABSDeletableTableDataHelper extends React.Component<IABSDeletableTableDataHelperProps, IABSDeletableTableDataHelperState> {
  static formatColumnsData(columnsData: any[], renderTitle: (column: any) => React.ReactNode) {
    if (Array.isArray(columnsData)) {
      return columnsData.map((column) => {
        if (!column.isFixed) {
          column.title = renderTitle(column);
          column.isFixed = true;
        }
        return column;
      });
    }
    return [];
  }

  static formatTableDataSource(item: any, columnsData: any[], contentData: any[]) {
    const key: string = item.title;
    columnsData.push({
      title: key,
      dataIndex: key,
      key: key,
      width: 200,
      isFixed: item.isFixed
    });

    contentData = contentData.map((row, index) => {
      const value = `随机内容：${generateRandomKey(5)}`;
      row[key] = value;
      return row;
    });
    return { columnsData, contentData };
  }

  static formatTableDataSourceInput(item: any, columnsData: any[], contentData: any[], inputVals: any, inputChange: (val: any, keys: string, index: number) => any, colRender: (value: any, record: any, index: number, inputArr: any[]) => any) {
    const { title, key, editableRowKeys, isFixed, placeholder = [], rule = [] } = item;
    const findRowKey = (rowIndex: number) => { return editableRowKeys[rowIndex]; };
    const inputArr: any[] = [];

    const onChange = (val: any, keys: string, index: number) => {
      if (inputArr[index]) {
        if (!inputArr[index].validatorValue(val || '0').pass) {
          inputChange('error', keys, index);
          return;
        }
      }
      inputChange(val, keys, index);
    };
    contentData = contentData.map((row, index) => {
      inputVals[key] = inputVals[key] ? inputVals[key] : {};
      const value = inputVals[key][findRowKey(index)] || '0';
      inputVals[key][findRowKey(index)] = value;
      const render = index < editableRowKeys.length ? <ABSInput ref={view => { inputArr.push(view); }} defaultValue={value} placeholder={placeholder[index]} rules={rule[index]} onChange={(val: any) => { onChange(val, key, index); }} contentWidth={175} removeMarginBottom={true}/> : '--';
      row[key] = render;
      return row;
    });
    inputVals[key].name = title;
    columnsData.push({
      title,
      dataIndex: key,
      key: key,
      width: 200,
      isFixed: isFixed,
      render: (value, record, index) => colRender(value, record, index, inputArr)
    });

    return { columnsData, contentData, inputVals };
  }
}
 
export default ABSDeletableTableDataHelper;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDeletableTable/ABSDeletableTableDataHelper.tsx